import React from 'react';
import { PROOF_EXTENSIONS } from '../../services/emailWorkflowApi';

/**
 * The ONE proof-file picker (UI rulebook: shared control, single source of styling).
 * Used by New Request (invoice) and the detail Finance card (payment proof).
 *
 * The native input is hidden: we reset it after every pick (so the same file can
 * be re-picked after a failure), which makes the browser's own "No file chosen"
 * label lie. Instead the ONLY filename display is ours — pass `fileName` when the
 * caller holds the file; leave it out when uploads are fire-and-forget.
 * Callers validate with validateProofFile() and own the error display.
 */
export const ProofFileInput: React.FC<{
	disabled?: boolean;
	fileName?: string | null;
	onFile: (file: File | null) => void;
}> = ({ disabled, fileName, onFile }) => (
	<div
		className={`flex items-center gap-3 rounded-md border border-dashed p-2 ${
			disabled ? 'border-gray-200 opacity-50' : 'border-gray-300 hover:border-primary'
		}`}
	>
		<label
			className={`shrink-0 rounded-md bg-primary px-4 py-1.5 text-sm font-medium text-white ${
				disabled ? '' : 'cursor-pointer hover:opacity-90'
			}`}
		>
			Choose file
			<input
				type="file"
				accept={PROOF_EXTENSIONS.join(',')}
				disabled={disabled}
				className="hidden"
				onChange={e => {
					const f = e.target.files?.[0] ?? null;
					e.target.value = ''; // reset so the same file can be re-picked after a failure
					onFile(f);
				}}
			/>
		</label>
		<span className={`truncate text-sm ${fileName ? 'font-medium text-green-700' : 'text-gray-400'}`}>
			{fileName ? `✓ ${fileName} attached` : 'No file attached yet'}
		</span>
	</div>
);
